<template lang="pug">
  BaseModal.ModalDisclaimerDisclosure(
    :value="value",
    v-bind="$attrs",
    v-on="$listeners",
    @close="$emit('cancel')"
  )
    template(#title) Site Disclosure
    .modal-disclosure-content
      p By using this Site, you are subject to our&nbsp;
        a.link-2(href="/company/terms" target="_blank") Terms of Use
        |  and our&nbsp;
        a.link-2(href="/company/privacy" target="_blank") Privacy Policy
        | . Please read these carefully before proceeding.
      p Our Site offers qualified investors the opportunity to invest in entities that will acquire different&nbsp;
        | types of land. However, we do not make recommendations regarding the appropriateness of any particular
        | opportunity for any particular investor.&nbsp;
        i We are not investment advisers.&nbsp;
        | Investors must make their own investment decisions, either alone or with their personal legal,
        | financial and tax advisors.
      p All real estate asset class investments, including those related to agricultural or timberland, can be risky&nbsp;
        | and unpredictable. Alternative investments are illiquid, considered speculative and involve a high degree of
        | risk, including the complete loss of principal and are not suitable for all investors. Farmland and timberland
        | investments are also subject to additional risks including volatility in commodity prices, weather events or
        | disease that could damage crops,  changing laws, including environmental laws; floods, fires, drought, and other
        | Acts of God, some of which can be uninsurable; changes in national or local economic conditions; changes in
        | government policies, including changes in interest rates established by the Federal Reserve; and international
        | crises. You should invest in farmland and timberland asset class investments in general, and in the opportunities
        | listed at the Site in particular, only if you can afford to lose your entire investment and are willing to live
        | with the ups and downs of the alternative asset class industry.
      p
        strong THE SITE DOES NOT CONSTITUTE AN OFFER TO SELL OR THE SOLICITATION OF AN OFFER TO BUY ANY SECURITY, NOR DOES IT&nbsp;
          | CONSTITUTE AN OFFER TO SELL OR THE SOLICITATION OF AN OFFER TO BUY SUCH SECURITIES BY ANYONE IN ANY JURISDICTION
          | IN WHICH SUCH OFFER OR SOLICITATION IS NOT AUTHORIZED, OR IN WHICH THE PERSON MAKING SUCH OFFER OR SOLICITATION IS
          | NOT QUALIFIED TO DO SO.  THIS IS NOT AN OFFER OF AN INVESTMENT OPPORTUNITY IN ANY JURISDICTION WHERE IT IS
          | PROHIBITED OR WHERE A PRE-FILING OR OTHER ACTION IS REQUIRED.
      p Neither the Securities and Exchange Commission nor any state agency has reviewed
        |  the investment opportunities listed on the Site.
      p Thank you for using the Site. If you have questions, please contact us at&nbsp;
        a.link-2(href="mailto:info@acretrader.com" target="_blank") info@acretrader.com
</template>

<script>
import BaseModal from 'Components/Base/BaseModal';

export default {
  name: 'ModalDisclaimerDisclosure',
  components: { BaseModal },
  props: {
    value: Boolean,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
::v-deep .modal__header
  background-color: $secondary
.modal-disclosure-content
  width: 100%
  max-width: 1140px
  height: auto
  margin: 0 auto
</style>
